<template>
  <div class="resource-center">
    <el-breadcrumb separator=">">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>资源中心</el-breadcrumb-item>
    </el-breadcrumb>
    <h1>资源中心</h1>
    <div class="table-div clearfix" v-loading="loading">
      <table class="statistics-table-stage" cellspacing="0" cellpadding="0">
        <tr><td>学段</td></tr>
        <tr v-for="(item,index) in data" :key="index">
          <td :style="{  height: heights[index] + 'px' }">{{item.stageName}}</td>
        </tr>
        <!-- <tr><td class="">合计</td></tr> -->
      </table>
      <table class="statistics-table" cellspacing="0" cellpadding="0">
        <tr>
          <td class="head">学科</td>
        </tr>
        <template v-for="stage in data" >
          <tr v-for="(sub, subindex) in stage.subjectDtos" :key="subindex">
            <td class="subject" :style="{  height: sub.versionAndNumberDtos.length * 40 + 'px' }">{{sub.subjectName}}</td>
          </tr>
        </template>
        <!-- <tr><td></td></tr> -->
      </table>
      <table class="statistics-table" cellspacing="0" cellpadding="0">
        <tr>
          <td class="head">版本</td>
          <td class="head">数量</td>
        </tr>
        <template v-for="stage in data">
            <template v-for="sub in stage.subjectDtos">
              <tr v-for="ver in sub.versionAndNumberDtos" :key="ver.documentNumbers+ver.versionName"><td>{{ver.versionName}}</td><td>{{ver.documentNumbers}}</td></tr>
            </template>
        </template>
        <!-- <tr>
          <td></td>
          <td>{{totaldocs}}</td>
        </tr> -->
      </table>
    </div>
  </div>
</template>
<script type="text/babel">
import commonService from '@/service/commonService'

export default {
  data: function () {
    return {
      heights: [],
      totaldocs: '',
      loading: false,
      data: [ // 类型：Array  必有字段  备注：无
        { // 类型：Object  必有字段  备注：无
          'stageName': '小学', // 类型：String  必有字段  备注：无
          'subjectDtos': [ // 类型：Array  必有字段  备注：无
            { // 类型：Object  必有字段  备注：无
              'subjectName': '语文', // 类型：String  必有字段  备注：无
              'versionAndNumberDtos': [ // 类型：Array  必有字段  备注：无
                { // 类型：Object  必有字段  备注：无
                  'versionName': '人教版（1990s）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 14807 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '人教版（2001）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 68574 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '北师大版（2001）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 13481 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '西师大版（2003）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 8377 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '苏教版（2001）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 35942 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '冀教版（2002）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 5848 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '鲁教版（五四学制）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 5315 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '沪教版（2007）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 6248 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '浙教版', // 类型：String  必有字段  备注：无
                  'documentNumbers': 359 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '语文S版（2003）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 9321 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '北京版（2004）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 3015 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '语文A版', // 类型：String  必有字段  备注：无
                  'documentNumbers': 2826 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '湘教版（2003）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 3646 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '教科版（2003）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 3456 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '长春版（2003）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 5683 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '鄂教版（2003）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 3066 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '教科版（五四学制）（2003）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 365 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '沪教版（2015）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 973 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '人教部编版（2016）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 3413 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '北京版（2016）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 27 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '语文S版（2016）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 86 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '苏教版（2016）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 1552 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '长春版（2016）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 10 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '北师大版（2016）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 1 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '教科版（五四学制）（2016）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 1 // 类型：Number  必有字段  备注：无
                }
              ]
            },
            { // 类型：Object  必有字段  备注：无
              'subjectName': '数学', // 类型：String  必有字段  备注：无
              'versionAndNumberDtos': [ // 类型：Array  必有字段  备注：无
                { // 类型：Object  必有字段  备注：无
                  'versionName': '人教版（1990s）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 4906 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '人教版（2001）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 29318 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '北师大版（2001）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 15350 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '西师大版（2001）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 5822 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '苏教版（2001）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 17343 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '冀教版（2001）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 4680 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '青岛版（2002）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 3926 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '沪教版（2001）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 3465 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '浙教版', // 类型：String  必有字段  备注：无
                  'documentNumbers': 433 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '北京版（2004）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 2299 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '青岛版（五四学制）（2001）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 1353 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '人教版（2012）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 18427 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '北师大版（2012）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 5749 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '西师大版（2012）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 3049 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '苏教版（2012）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 7774 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '冀教版（2012）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 3677 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '青岛版（2012）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 2552 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '北京版（2013）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 856 // 类型：Number  必有字段  备注：无
                }
              ]
            },
            { // 类型：Object  必有字段  备注：无
              'subjectName': '英语', // 类型：String  必有字段  备注：无
              'versionAndNumberDtos': [ // 类型：Array  必有字段  备注：无
                { // 类型：Object  必有字段  备注：无
                  'versionName': '人教（新版）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 4629 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '人教PEP版（2003）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 6652 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '北师大版（一起）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 181 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '冀教版（三起）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 4578 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '沪教版', // 类型：String  必有字段  备注：无
                  'documentNumbers': 2302 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '牛津译林版（2006）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 7183 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '人教新起点版（2002）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 3535 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '译林版（三起）（2012）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 4636 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '粤人版（开心英语）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 1224 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '湘少版（三起）（2003）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 465 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '辽师大版（一起）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 300 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '闽教版', // 类型：String  必有字段  备注：无
                  'documentNumbers': 921 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '教科版（EEC）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 458 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '广州版', // 类型：String  必有字段  备注：无
                  'documentNumbers': 1577 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '新世纪英语', // 类型：String  必有字段  备注：无
                  'documentNumbers': 692 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '外研版（一起）（2002）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 1497 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '教科版（广州）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 503 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '冀教版（一起）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 1049 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '川教版（三起）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 673 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '陕旅版（三起）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 1977 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '北京版', // 类型：String  必有字段  备注：无
                  'documentNumbers': 624 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '外研版（三起）（2012）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 4236 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '湘少版（三起）（2012）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 1389 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '科普版', // 类型：String  必有字段  备注：无
                  'documentNumbers': 570 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '湘鲁版', // 类型：String  必有字段  备注：无
                  'documentNumbers': 329 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '新概念英语青少版', // 类型：String  必有字段  备注：无
                  'documentNumbers': 1 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '深港朗文版', // 类型：String  必有字段  备注：无
                  'documentNumbers': 541 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '人教PEP版（2012）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 9186 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '人教新起点版（2012）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 1542 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '北师大版（三起）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 483 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '人教精通版（2012）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 1694 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '牛津上海版（试用本）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 895 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': 'Join in 剑桥英语', // 类型：String  必有字段  备注：无
                  'documentNumbers': 70 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '外研版（一起）（2012）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 2065 // 类型：Number  必有字段  备注：无
                }
              ]
            },
            { // 类型：Object  必有字段  备注：无
              'subjectName': '道德与法治', // 类型：String  必有字段  备注：无
              'versionAndNumberDtos': [ // 类型：Array  必有字段  备注：无
                { // 类型：Object  必有字段  备注：无
                  'versionName': '人教版（2002）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 2898 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '人教版（部编）（2016）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 112 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '北师大版（2002）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 1577 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '苏教版（2002）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 1237 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '冀人版（2002）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 1197 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '鲁教版（五四制）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 75 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '浙教版（2002）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 990 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '粤教版（2003）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 196 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '教科版', // 类型：String  必有字段  备注：无
                  'documentNumbers': 276 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '首师大版（北京）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 394 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '鄂教版（2004）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 1086 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '泰山版（2004）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 410 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '辽海版（2004）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 182 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '人民未来版', // 类型：String  必有字段  备注：无
                  'documentNumbers': 321 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '鲁美版（2003）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 6 // 类型：Number  必有字段  备注：无
                }
              ]
            },
            { // 类型：Object  必有字段  备注：无
              'subjectName': '科学', // 类型：String  必有字段  备注：无
              'versionAndNumberDtos': [ // 类型：Array  必有字段  备注：无
                { // 类型：Object  必有字段  备注：无
                  'versionName': '苏教版', // 类型：String  必有字段  备注：无
                  'documentNumbers': 2160 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '冀人版', // 类型：String  必有字段  备注：无
                  'documentNumbers': 777 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '教科版', // 类型：String  必有字段  备注：无
                  'documentNumbers': 5236 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '青岛版（五四学制）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 840 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '鄂教版', // 类型：String  必有字段  备注：无
                  'documentNumbers': 424 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '青岛版', // 类型：String  必有字段  备注：无
                  'documentNumbers': 740 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '湘科版', // 类型：String  必有字段  备注：无
                  'documentNumbers': 227 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '大象版', // 类型：String  必有字段  备注：无
                  'documentNumbers': 454 // 类型：Number  必有字段  备注：无
                }
              ]
            },
            { // 类型：Object  必有字段  备注：无
              'subjectName': '信息技术', // 类型：String  必有字段  备注：无
              'versionAndNumberDtos': [ // 类型：Array  必有字段  备注：无
                { // 类型：Object  必有字段  备注：无
                  'versionName': '人教版（三起）（2001）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 510 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '冀教版', // 类型：String  必有字段  备注：无
                  'documentNumbers': 452 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '闽教版（2008）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 260 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '龙教版（三起）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 330 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '河大版（河北）（三起）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 46 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '南方版（湖南）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 50 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '泰山版', // 类型：String  必有字段  备注：无
                  'documentNumbers': 290 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '浙江摄影版（三起）（2005）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 310 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '川教版（三起）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 178 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '苏科版（2015）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 195 // 类型：Number  必有字段  备注：无
                }
              ]
            },
            { // 类型：Object  必有字段  备注：无
              'subjectName': '音乐', // 类型：String  必有字段  备注：无
              'versionAndNumberDtos': [ // 类型：Array  必有字段  备注：无
                { // 类型：Object  必有字段  备注：无
                  'versionName': '人教版（2001）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 1319 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '苏少版（2003）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 424 // 类型：Number  必有字段  备注：无
                },
                -{ // 类型：Object  必有字段  备注：无
                  'versionName': '人音版（2001）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 1015 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '湘艺版（2001）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 14 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '苏少版（2012）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 1027 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '人教版（2012）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 1793 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '人音版（2012）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 2115 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '湘艺版（2012）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 577 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '人音版（五线谱）（北京）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 253 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '花城版', // 类型：String  必有字段  备注：无
                  'documentNumbers': 569 // 类型：Number  必有字段  备注：无
                }
              ]
            },
            { // 类型：Object  必有字段  备注：无
              'subjectName': '美术', // 类型：String  必有字段  备注：无
              'versionAndNumberDtos': [ // 类型：Array  必有字段  备注：无
                { // 类型：Object  必有字段  备注：无
                  'versionName': '人教版（2001）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 1209 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '冀美版（2001）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 238 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '沪教版', // 类型：String  必有字段  备注：无
                  'documentNumbers': 235 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '湘美版（2003）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 460 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '人美版（2001）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 115 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '苏少版', // 类型：String  必有字段  备注：无
                  'documentNumbers': 366 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '浙美版（2001）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 9 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '人美版（北京）（2001）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 155 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '岭南版', // 类型：String  必有字段  备注：无
                  'documentNumbers': 697 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '人教版（2012）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 140 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '冀美版（2012）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 143 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '人美版（2012）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 297 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '湘美版（2012）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 490 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '赣美版', // 类型：String  必有字段  备注：无
                  'documentNumbers': 409 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '浙美版（2012）', // 类型：String  必有字段  备注：无
                  'documentNumbers': 138 // 类型：Number  必有字段  备注：无
                },
                { // 类型：Object  必有字段  备注：无
                  'versionName': '广西版', // 类型：String  必有字段  备注：无
                  'documentNumbers': 161 // 类型：Number  必有字段  备注：无
                }
              ]
            }
          ]
        }
      ]
    }
  },
  name: 'resourceCenter',
  async mounted () {
    await this.getDocumentNum()
  },
  methods: {
    async getDocumentNum () {
      this.loading = true
      try {
        let resp = await commonService.getDocumentNum()
        let dataFor = resp.data.stageDto
        if (dataFor && dataFor.length > 0) {
          for (let item of dataFor) {
            let length = 0
            for (let sub of item.subjectDtos) {
              length += sub.versionAndNumberDtos.length
            }
            this.heights.push(length * 40)
          }
        }

        this.data = dataFor
        this.totaldocs = resp.data.allDocumentNumbers
        this.loading = false
      } catch (e) {
        this.$message.error(e && e.msg)
        this.loading = false
      }
    }
  }
}
</script>
<style scoped>
</style>
<style>
  .resource-center{
    width: 1200px;
    margin: 0px auto;
    padding: 24px 0px;
  }
  .resource-center h1{
    width: 125px;
    margin: 40px auto 30px;
    font-size:24px;
    font-family:MicrosoftYaHei;
    font-weight:400;
    color: #000000;
  }

  .resource-center .statistics-table-stage{
    border:1px solid #0096FF;
    background:linear-gradient(153deg,#1D3981,#00BF8F);
    width: 300px;
    text-align: center;
    font-size: 16px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    border-collapse:separate;
    color: #ffffff;
    font-weight: bold;
    float: left;
  }

  .resource-center .statistics-table-stage td{
    border-top: 0;
    border-bottom: 1px solid #ffffff;
    border-right: 0;
    border-left: 0;
  }

  .resource-center .statistics-table-stage tr:last-child td {
    border-bottom: 0;
  }

  .resource-center .statistics-table-stage tr td{
    width: 300px;
    height: 40px;
  }

  .resource-center .statistics-table .head{
    font-weight:bold;
    color: #002488;
    height: 40px;
  }

  .resource-center .statistics-table tr td{
    width: 299px;
    height: 40px;
    font-weight:400;
    color:#666666;
  }

  .resource-center .statistics-table .subject{
    font-weight:bold;
    color:#333333;
  }

  .resource-center .statistics-table{
    border-top:1px solid #0096FF;
    border-right:1px solid #0096FF;
    border-bottom:1px solid #0096FF;
    /* width: 900px; */
    text-align: center;
    font-size: 16px;
    /* border-top-right-radius: 5px;
    border-bottom-right-radius: 5px; */
    border-collapse:separate;
    float: left;
  }

  .resource-center .statistics-table td {
    border-right: 1px solid #0096FF;
    border-bottom: 1px solid #0096FF;
    border-top: 0;
    border-left: 0;
  }

  .resource-center .statistics-table tr:last-child td {
    border-bottom: 0;
  }

  .resource-center .statistics-table .special {
    border-bottom: 0;
  }

  .resource-center .statistics-table tr td:last-child {
    border-right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/front/introduce/resource-center/index.vue